import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useReducer
} from 'react';
import useTranslations from '../../../hooks/useTranslations';
import FlaggingQueryBuilderView from '../view/FlaggingQueryBuilderView';

// not flagged: [{"field":"'flagged'","op":"=","value":"false"}, {"field":"'flagged'","op":"IS NULL", "internOp":"OR"}]
// flagged: [{"field":"'flagged'","op":"=","value":"true"}]

const FlaggingQueryBuilderReducer = (state, action) => {
  const { type, payload, index } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    default:
      return state;
  }
};

const initialState = { query: [] };

const FlaggingQueryBuilderEngine = ({
  query = [],
  update = () => {},
  sentencePrefix
}) => {
  const t = useTranslations();
  const [flaggedValue, setFlaggedValue] = useState('flagged');
  const [data, dispatch] = useReducer(
    FlaggingQueryBuilderReducer,
    initialState
  );
  const skipUpdate = useRef(true);

  useEffect(() => {
    if (skipUpdate.current) {
      skipUpdate.current = false;
      return;
    }
    update(data.query);
  }, [data]);

  useEffect(() => {
    if (!!query.length && !!query[0].value) {
      skipUpdate.current = true;
      dispatch({ type: 'update', payload: { query } });
      if (query.length > 1) {
        setFlaggedValue('not_flagged');
      }
      return;
    }
    // init defualt
    dispatch({
      type: 'update',
      payload: { query: [{ field: "'flagged'", op: '=', value: 'true' }] }
    });
  }, []);

  const onFlaggingChanged = useCallback(value => {
    setFlaggedValue(value);
    if (value === 'flagged') {
      dispatch({
        type: 'update',
        payload: { query: [{ field: "'flagged'", op: '=', value: 'true' }] }
      });
    } else {
      dispatch({
        type: 'update',
        payload: {
          query: [
            { field: "'flagged'", op: '=', value: 'false' },
            { field: "'flagged'", op: 'IS NULL', internOp: 'OR' }
          ]
        }
      });
    }
  }, []);

  const viewProps = {
    sentencePrefix: sentencePrefix || t('logic.when_flagged'),
    flaggedValue,
    onFlaggingChanged
  };

  return <FlaggingQueryBuilderView {...viewProps} />;
};

export default FlaggingQueryBuilderEngine;
